import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import {
  base_colorContentBorder,
  blue400,
  grey50,
  grey200,
} from 'ext-ui/style/colors'
import { css } from 'styled-components'

/**
 * Styles for the shared date-range preset menu body (option rows, optional
 * custom calendar with back, and the reset footer). Positioning of the menu is
 * left to the consumer — transactions positions it inside the data-grid toolbar
 * dropdown, reporting positions it under its inline trigger.
 */
export default css`
  &.DateRangePresetMenu {
    display: flex;
    flex-direction: column;

    & .container {
      display: flex;
      flex-direction: column;
      box-shadow: 0 4px 10px 0 rgba(25, 16, 16, 0.1);
      background-color: ${styleConstants.colors.white};
      border: 1px solid ${blue400};
      border-radius: 8px;
      overflow: hidden;

      &.small {
        width: 300px;
        height: auto;
      }

      &.large {
        width: 368px;
        height: 500px;
      }
    }

    .option {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
      margin: 0;
      border: none;
      background: none;
      text-align: left;
      font: inherit;
      cursor: pointer;
      padding: 12px 18px;

      &.active {
        background-color: ${styleConstants.colors.gray_light};
      }

      &:hover {
        background-color: ${grey200};
      }

      &:focus-visible {
        outline: 2px solid ${themeConstants.colors.cta};
        outline-offset: -2px;
      }
    }

    .option-type {
      ${getFontCss(
        14,
        themeConstants.colors.cta,
        styleConstants.fontFamilies.regular,
      )};
    }

    .option-value {
      display: flex;
      white-space: normal;
      ${getFontCss(
        10,
        themeConstants.colors.font_primary,
        styleConstants.fontFamilies.regular,
      )};
    }

    .custom-option {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
      margin: 0;
      border: none;
      cursor: pointer;
      padding: 12px 18px;
      background-color: transparent;

      ${getFontCss(
        14,
        themeConstants.colors.cta,
        styleConstants.fontFamilies.regular,
      )};

      &.active {
        background-color: ${styleConstants.colors.gray_light};
      }

      &:hover {
        background-color: ${grey200};
      }

      &:focus-visible {
        outline: 2px solid ${themeConstants.colors.cta};
        outline-offset: -2px;
      }
    }

    .back-button {
      display: flex;
      align-items: center;
      padding: 0 20px;
      height: 42px;
      width: 100%;
      border-bottom: 1px solid ${styleConstants.colors.gray_medium};
      cursor: pointer;
      background: ${styleConstants.colors.gray_lightest};
      ${getFontCss(
        14,
        themeConstants.colors.cta,
        styleConstants.fontFamilies.medium,
      )};
    }

    .reset-container {
      border-radius: 0 0 var(--border-radius) var(--border-radius);
      background: ${grey50};
      padding: 8px;
      border-top: 1px solid ${base_colorContentBorder};
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .reset-button {
      padding: 8px;
    }
  }
`
